import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormGroup, InputGroup, FormControl, Glyphicon, Row, Col } from 'react-bootstrap';

import './OskariMap.css';

class OskariMapSearch extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchText: '',
      resultHandlerInitialized: false
    };

    this.updateSearchText = this.updateSearchText.bind(this);
    this.searchFromMap = this.searchFromMap.bind(this);
    this.searchBoxKeyPress = this.searchBoxKeyPress.bind(this);
  }

  addResultHandler() {
    this.props.addEventHandler('SearchResultEvent', this.showSearchResult.bind(this));
    this.setState({ resultHandlerInitialized: true });
  }

  updateSearchText(event) {
    this.setState({ searchText: event.target.value });
  }

  searchBoxKeyPress(event) {
    if (event.key === 'Enter') {
      this.searchFromMap();
    }
  }

  searchFromMap() {
    if (!this.state.resultHandlerInitialized) {
      this.addResultHandler();
    }

    this.props.channelRequest('SearchRequest', [this.state.searchText]);
  }

  showSearchResult(response) {
    const location = response.result.locations[0];

    if (location) {
      this.props.channelRequest('MapMoveRequest', [location.lon, location.lat, 6]);
    }
  }

  render() {
    return (
      <div className="map-search">
        <Row>
          <Col xsHidden sm={6} smOffset={5} md={6} mdOffset={5}>
            <FormGroup>
              <InputGroup>
                <FormControl
                  type="text"
                  placeholder="Haku"
                  onChange={this.updateSearchText}
                  onKeyPress={this.searchBoxKeyPress}
                />
                <InputGroup.Addon>
                  <Glyphicon glyph="search" onClick={this.searchFromMap} />
                </InputGroup.Addon>
              </InputGroup>
            </FormGroup>
          </Col>
        </Row>
      </div>
    );
  }
}


OskariMapSearch.propTypes = {
  channelRequest: PropTypes.func.isRequired,
  addEventHandler: PropTypes.func.isRequired
};

export default OskariMapSearch;



// WEBPACK FOOTER //
// ./src/components/map/OskariMapSearch.jsx